import {TFunction} from "i18next";

const COMPANY_SCOPE_SUFFIX = "_company";

/** Resolves a chart or compare-row metric id to its display label. A
 *  "_company" suffix marks parent company scope: it is stripped before
 *  lookup and the company scope phrase is appended after translation. An
 *  id with no translation key (the key comes back unresolved) returns the
 *  raw id as is, so a caption never shows a raw i18next key.
 *  Shared by ChartBlock, CompareBlock and their plain-text renderings. */
export const metricLabel = (metricId: string, t: TFunction): string => {
    const isCompanyScope = metricId.endsWith(COMPANY_SCOPE_SUFFIX);
    const baseId = isCompanyScope
        ? metricId.slice(0, -COMPANY_SCOPE_SUFFIX.length)
        : metricId;
    const key = `metric.${baseId}`;
    const translated = t(key);
    if (!translated || translated === key) {
        return metricId;
    }
    return isCompanyScope ? `${translated} ${t("metric.companyScope")}` : translated;
};
